import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import EmailBuilder from "./pages/EmailBuilder";
import ProManager from "./pages/ProManager/ProManager";
import Login from "./pages/Login";
import InstallPrompt from "./components/InstallPrompt";
import { AuthProvider, useAuth } from "./context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-[#D4AF37] text-lg font-semibold animate-pulse">Loading...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><EmailBuilder /></ProtectedRoute>} />
            <Route path="/pro-manager" element={<ProtectedRoute><ProManager /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <InstallPrompt />
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#18181b',
            border: '1px solid #27272a',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

export default App;
